import { firebaseServerConfig } from '../environments/environment';

// add your info here
export const firebaseConfig = firebaseServerConfig;

